import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import CustomPrevArrow from "./CustomPrevArrow";
import CustomNextArrow from "./CustomNextArrow";

const Carousel = ({
    autoPlay,
    autoPlayInterval,
    displayDots,
    items,
    lazyLoad,
    loop,
    pageScroll,
    pageSize,
    speed,
}) => {
    const settings = {
        autoplay: autoPlay,
        autoplaySpeed: autoPlayInterval,
        dots: displayDots,
        infinite: items.length > pageSize ? loop : false,
        speed: speed,
        slidesToShow: pageSize,
        slidesToScroll: pageScroll,
        lazyLoad: lazyLoad,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    infinite: true
                }
            }
        ],
        prevArrow: <CustomPrevArrow />,
        nextArrow: <CustomNextArrow />
    };

    return items.length > 0 ? (
        <Slider {...settings}>
            {items.map((item, index) => <div key={`carousel-item-${index}`}>{item}</div>)}
        </Slider>
    ) : null;
};

Carousel.defaultProps = {
    autoPlay: false,
    autoPlayInterval: 3000,
    displayDots: true,
    lazyLoad: true,
    loop: true,
    pageScroll: 1,
    pageSize: 3,
    speed: 500
};

Carousel.propTypes = {
    autoPlay: PropTypes.bool.isRequired,
    autoPlayInterval: PropTypes.number.isRequired,
    displayDots: PropTypes.bool.isRequired,
    items: PropTypes.array.isRequired,
    lazyLoad: PropTypes.bool.isRequired,
    loop: PropTypes.bool.isRequired,
    pageScroll: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    speed: PropTypes.number.isRequired
};

export default Carousel;